/**
 * Form-field shapes shared by the online POST and the offline replay.
 *
 * This module deliberately imports nothing: both `submitAddressComment` and
 * `OfflineContext` need it, and those two already depend on each other.
 */

/**
 * The observation half of an address-comment submission.
 *
 * A field observation is an ordinary comment that also carries a shared,
 * office-owned status. Correction windows live on the violation, never on the
 * code, so `suggestedDeadline` is only a hint the desk is free to change.
 */
export const observationFormFields = (observation) => {
  if (!observation) return {};
  return {
    is_potential_violation: 'true',
    condition_code_id: observation.conditionCodeId ?? null,
    suggested_violation_type: observation.suggestedViolationType ?? null,
    suggested_deadline: observation.suggestedDeadline ?? null,
  };
};

/**
 * The access-attempt half of an address-comment submission.
 *
 * Sent as explicit fields rather than inferred from the comment's geo metadata:
 * that metadata is dropped entirely when location is unavailable, which is
 * common at the curb, and the offline queue does not replay it at all.
 */
export const accessAttemptFormFields = (accessAttempt) => {
  if (!accessAttempt) return {};
  return {
    access_attempt_method: accessAttempt.method || 'site_visit',
    access_attempt_outcome: accessAttempt.outcome ?? null,
    access_attempt_contact_name: accessAttempt.contactName ?? null,
    access_attempt_note: accessAttempt.note ?? null,
  };
};

export default observationFormFields;
